module.exports = __webpack_public_path__ + "static/media/thumbnail.743a2670.webp";